import { render, staticRenderFns } from "./ASLNotificationBar.vue?vue&type=template&id=5af0dcce&scoped=true"
import script from "./ASLNotificationBar.vue?vue&type=script&lang=js"
export * from "./ASLNotificationBar.vue?vue&type=script&lang=js"
import style0 from "./ASLNotificationBar.vue?vue&type=style&index=0&id=5af0dcce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../deps/0/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af0dcce",
  null
  
)

export default component.exports